import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

/**
 *
 * @param {HTMLElement} filterElement
 * @returns {JSX.Element}
 * @constructor
 */
const CategoryFilter = ({ filterElement }) => {
    const { categoryTabOpen } = useSelector((state) => state.facetedSearch);

    let elClass = 'category-filtering small-navigation-tab';
    elClass += (categoryTabOpen ? '' : ' closed hide-filter');

    useEffect(() => {
        document.dispatchEvent(new Event('categoryFilterRendered'))
    }, []);

    return (
        <div className={elClass} dangerouslySetInnerHTML={{
            __html: filterElement.innerHTML,
        }}></div>
    );
};

export default CategoryFilter;